import React from "react";
import Postlogin from "./Postlogin";
import Prelogin from "./Prelogin";
import { useSelector } from "react-redux";


const Routers = () => {

    const {isLoggedIn} = useSelector(state => state.user);

    return(
        <>
            {isLoggedIn ? <Postlogin /> : <Prelogin />}
        </>
    )
} 

export default Routers;